import { isPlatformBrowser, NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantDto } from '@picflow/types';
import { getAllRouteData } from 'src/app/lib/get-all-route-data';
import { getFormControl } from 'src/app/lib/get-form-control';
import { getFullPath } from 'src/app/lib/get-full-path';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { GalleryPasswordService } from 'src/app/services/gallery-password.service';
import { GalleryService } from 'src/app/services/gallery.service';
import { ToastService } from 'src/app/services/toast.service';
import { AutofocusDirective } from 'src/app/shared/directives/autofocus.directive';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TenantIconLoaderComponent } from '../../components/tenant-icon-loader/tenant-icon-loader.component';

@Component({
  selector: 'app-gallery-password-page',
  templateUrl: './gallery-password-page.component.html',
  styleUrls: ['./gallery-password-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    SvgComponent,
    FormsModule,
    ReactiveFormsModule,
    InputFieldComponent,
    ButtonDirective,
    LoadingIndicatorComponent,
    TenantIconLoaderComponent,
    AutofocusDirective,
  ],
})
export class GalleryPasswordPageComponent {
  form = new FormGroup({
    password: getFormControl('gallery-password'),
  });
  platformBrowser: boolean;
  loading = false;
  tenant: TenantDto;

  constructor(
    private galleryService: GalleryService,
    private route: ActivatedRoute,
    private router: Router,
    private galleryPasswordService: GalleryPasswordService,
    private analytics: AnalyticsService,
    private toasts: ToastService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.platformBrowser = isPlatformBrowser(this.platformId);
    this.tenant = getAllRouteData(this.route.snapshot).tenant;
  }

  async submit() {
    if (this.loading) return;
    if (!this.form.valid) return;
    this.loading = true;
    const idOrPath = this.route.snapshot.params.galleryPath;
    try {
      const password = this.form.value.password;
      this.galleryPasswordService.setPassword(idOrPath, password);
      await this.galleryService.getPublicGalleryFromSnapshot(this.route.snapshot, {
        ignore401Errors: true,
        isPublic: true,
      });
      this.analytics.track('valid_gallery_password');
      const url = getFullPath(this.route.snapshot);
      url.splice(url.indexOf('access'), 1);
      this.router.navigate(url, { queryParamsHandling: 'preserve' });
    } catch (error) {
      this.loading = false;
      if (!(error instanceof HttpErrorResponse)) throw error;
      this.galleryPasswordService.removePassword(idOrPath);
      this.analytics.track('invalid_gallery_password');
      this.toasts.add('Password is not correct', 'error');
    }
  }
}
